type TourActiveToggleType = {
    active: boolean
    disabled?: boolean
    onChange: (active: boolean) => void
}

export default function TourActiveToggle(props: TourActiveToggleType) {
    return (
        <div className="flex flex-col w-full min-w-[10rem]">
            <label className="text-sm pl-2 pb-1">Status</label>
            <button
                type="button"
                disabled={props.disabled}
                onClick={() => props.onChange(!props.active)}
                className="h-14 w-full bg-white shadow-lg rounded-default px-4 flex items-center justify-between gap-3 border-none hover:bg-gray-50 disabled:opacity-50">
                <span className="text-sm font-medium truncate">{props.active ? "Aktiv" : "Pausiert"}</span>
                <input
                    type="checkbox"
                    readOnly
                    tabIndex={-1}
                    checked={props.active}
                    className="toggle toggle-primary pointer-events-none shrink-0"
                    aria-hidden
                />
            </button>
        </div>
    )
}
